import { useTranslate } from "../../../common/hooks/useTranslate";

import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import {
  DashboardDialog,
  DashboardDialogBody,
  DashboardDialogContent,
  DashboardDialogFooter,
  DashboardDialogHeader,
} from "@/dashboard-design-system/DashboardDialog";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

export const AvailableSoonModal = ({ isOpen, close }: { isOpen: boolean; close: () => void }) => {
  const { t } = useTranslate();
  return (
    <DashboardDialog open={isOpen}>
      <DashboardDialogHeader
        title={t("dashboard", "availableSoonModal.title")}
        slotProps={{ closeButton: { sx: { display: "none" } } }}
      />
      <DashboardDialogBody
        slots={{
          content: (
            <DashboardDialogContent>
              <DashboardTypography variant="body2" vibe="text-neutral-moderate">
                {t("dashboard", "availableSoonModal.description")}
              </DashboardTypography>
            </DashboardDialogContent>
          ),
          footer: (
            <DashboardDialogFooter>
              <DashboardButton onClick={close}>{t("dashboard", "availableSoonModal.gotIt")}</DashboardButton>
            </DashboardDialogFooter>
          ),
        }}
      />
    </DashboardDialog>
  );
};
